import { tRPCProxyClient } from '../../../utils/trpc';
import { AddressAssociationFeedbackType } from '../../../server/apiHelpers/provider-feedback/types';
import { EMRConfigData, RM_SITECONNECT_EMR_MAP } from './EMRConfigs/RRAOnboardingTracker';

export const sendDocusignSlackAlert = async (agreementId: string) => {
    let states: string[] = [];
    let numRequests = null;
    const tenant = await tRPCProxyClient.tenant.getTenant.query(undefined);

    const metadata = tenant?.digitalMetadata;
    if (!metadata || !metadata.emr || !metadata.emrEnvironment) {
        console.error('No metadata found for tenant');
        return;
    }

    try {
        console.log('Fetching tenant location data for slack alert');
        const addressFeedbackData = await tRPCProxyClient.tenant.getPendingAddressFeedback.query();
        const tenantSites = await tRPCProxyClient.tenant.getTenantSites.query();

        if (addressFeedbackData) {
            states = states.concat(
                addressFeedbackData
                    .filter(feedback => feedback.feedbackType === AddressAssociationFeedbackType.ADD)
                    .map(feedback => feedback.state)
            );
        }
        if (tenantSites) {
            states = states.concat(tenantSites.startEndBlock.map(row => row.state));
        }
        // dedup
        states = Array.from(new Set(states));
    } catch (error) {
        // catch error because we still want to send the slack alert
        console.error('Error fetching tenant location data for slack alert', error);
    }

    try {
        numRequests = (await tRPCProxyClient.requestManager.rmRouter.getDigitalEligibleRequestCounts.query())
            .eligible;
    } catch (error) {
        // catch error because we still want to send the slack alert
        console.error('Error fetching volume for slack alert', error);
    }

    try {
        await tRPCProxyClient.autofulfill.sendAutofulfillAgreementAlert.mutate({
            agreementId,
            numRequests,
            states,
        });
    } catch (error) {
        console.error('Error sending slack alert', error);
    }
};

export const openSCConnector = (configData: EMRConfigData) => {
    let url = 'https://dvconnector.healthjump.com';

    if (configData.emr && RM_SITECONNECT_EMR_MAP[configData.emr]) {
        url = `${url}/${encodeURI(RM_SITECONNECT_EMR_MAP[configData.emr])}`;
    }

    if (configData.digitalSiteId) {
        url = `${url}?digitalSiteId=${configData.digitalSiteId}`;
    }
    window.open(url, '_blank');
};
